








import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'TradesToDoWizard',
    components: {},
})
export default class TradesToDoWizard extends Vue {
    private next() {
        this.$router.push({
            name: 'TradeToDosList',
            query: {
                referrer: 'projects',
            },
        });
    }
}
